export const getDeviceName = () => undefined;
